import axios from "../../../services/axios-config";

export async function updateNextPayment({ companyId, cost, nextPayment }) {
    const res = await axios.patch(`/admin/companies/payments/next`, { companyId, cost, nextPayment });
    return res?.data;
}
